import React from 'react';
import {
  AuthenticationField,
  AuthenticationFieldProps
} from '@cube3/cubicle/src/core/atoms/AuthenticationField';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { getErrorMessage } from '../utils/getErrorMessage';
import { FieldWithState } from '../types/GenericFormTypes';

export type AuthCodeFieldProps = Omit<AuthenticationFieldProps, 'onChange'> & {
  submitError?: string;
};
type Props = FieldWithState<string, 'authentication'>;

export const AuthCodeField = (props: Props) => {
  const {
    //input,
    // meta
    error,
    invalid,
    active,
    submitFailed,
    //
    showErrors = true,
    submitError,
    ...extraProps
  } = props;
  const shouldError = !active && (invalid || submitFailed);

  const validateError = error && getErrorMessage(error);

  const errorMessage = submitError || validateError;

  return (
    <VBox gap={8}>
      <AuthenticationField {...extraProps} criticalState={!!errorMessage} />
      {showErrors && shouldError && errorMessage ? (
        <Typography color="critical">{errorMessage}</Typography>
      ) : null}
    </VBox>
  );
};
